import Heading from "components/heading/Heading";

const Publications = ({ data }) => {
    return (
        <div className="publications details-section" id="publications">
            <Heading>Publications</Heading>
            <div className="information">
                <ol className="numbered-list">
                    {data.map((v, i) => {
                        return (
                            <li className="numbered-list-item" key={v}>
                                <p>{v}</p>
                            </li>
                        );
                    })}
                </ol>
            </div>
        </div>
    );
};
export default Publications;
